import { commentItems } from '@/mocks/homeData';

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-10">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-medium mb-3">
              <i className="ri-chat-smile-2-line"></i>
              吃瓜热评
            </div>
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-950">
              吃瓜群众都在说
            </h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
            {commentItems.map((item) => (
              <div
                key={item.id}
                className="bg-background-50 border border-background-200 rounded-xl p-5"
              >
                <div className="flex items-center gap-3 mb-4">
                  <div className="w-11 h-11 rounded-full overflow-hidden flex-shrink-0 border-2 border-primary-100">
                    <img
                      src={item.avatar}
                      alt={item.nickname}
                      className="w-full h-full object-cover"
                      width="44"
                      height="44"
                    />
                  </div>
                  <div className="flex-1 min-w-0">
                    <div className="flex items-center gap-2">
                      <span className="font-sans font-semibold text-sm text-foreground-900 truncate">
                        {item.nickname}
                      </span>
                      <span className="flex-shrink-0 px-1.5 py-0.5 text-[10px] font-medium text-primary-600 bg-primary-100 rounded">
                        {item.tag}
                      </span>
                    </div>
                    <span className="text-xs text-foreground-400">{item.time}</span>
                  </div>
                </div>
                <p className="text-sm text-foreground-600 leading-relaxed mb-4">
                  {item.content}
                </p>
                <div className="flex items-center gap-4 text-xs text-foreground-400">
                  <span className="flex items-center gap-1 cursor-pointer hover:text-primary-500 transition-colors">
                    <i className="ri-thumb-up-line"></i>
                    {item.likes}
                  </span>
                  <span className="flex items-center gap-1 cursor-pointer hover:text-primary-500 transition-colors">
                    <i className="ri-chat-1-line"></i>
                    回复
                  </span>
                  <span className="flex items-center gap-1 cursor-pointer hover:text-primary-500 transition-colors">
                    <i className="ri-share-line"></i>
                    分享
                  </span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}